<template>
  <card
    :id="card.id"
    :key="card.id"
    :title="card.title"
    :subtitle-regular="getUpdateTime.phrase"
    :subtitle-highlight="getUpdateTime.time"
    :class="{ 'card-disabled': card.disabled }"
  >
    <component
      :is="card.component.name"
      v-if="card.visible"
      :key="card.component.key"
      :content="card.component.content"
      @click="handleClick"
    />
    <infotip
      v-if="card.disabled"
      :id="card.id + '-disabled'"
      :key="card.id + '-infotip-disabled'"
      :text="card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'"
      :auto-open-on-first-days="false"
      :never-open-again-after-dismissed="false"
      :close-on-mouse-leave="true"
    />
  </card>
</template>

<script>
import Card from '../Card'
import Infotip from '@/components/common/infotip/Infotip'
import CountIndicator from '../Widgets/CountIndicator'
import { mapGetters } from 'vuex'
import { DASHBOARD_FAST_LINKS, eventBus } from '@/api/eventbus'

export default {
  name: 'CardRecollects',
  components: {
    card: Card,
    infotip: Infotip,
    'count-indicator': CountIndicator
  },
  computed: {
    ...mapGetters(['getUpdateTime']),
    ...mapGetters(['totalPendente']),
    ...mapGetters(['toggle']),
    card() {
      return {
        id: 'recollects',
        visible: true,
        disabled: !this.toggle.recollect,
        disabledMessage: 'Essa funcionalidade encontra-se desabilitada pois está em fase de testes.',
        title: 'Recoletas',
        updateTimeVisible: true,
        toggle: 'recollect',
        component: {
          name: 'count-indicator',
          content: {
            number: this.totalPendente,
            text: '',
            color: 'dark-orange',
            icon: 'tubes',
            action: 'recollects',
            sizeBig: true
          }
        }
      }
    }
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: '/recollect/search'
      })
    },
    created() {
      let self = this
      eventBus.$on(DASHBOARD_FAST_LINKS, function (param) {
        self.callAction(param)
      })
    }
  }
}
</script>
